/* eslint-disable */
import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey,
} from '../constants/defaultValues';
import moment from 'moment';

export const mapOrder = (array, order, key) => {
  // eslint-disable-next-line func-names
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem('direction')) {
      const localValue = localStorage.getItem('direction');
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getDirection -> error', error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};
export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem('direction', direction);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setDirection -> error', error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentColor -> error', error);
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentColor -> error', error);
  }
};

export const getCurrentRadius = () => {
  let currentRadius = 'flat';
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentRadius -> error',
      error
    );
    currentRadius = 'flat';
  }
  return currentRadius;
};
export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentRadius -> error',
      error
    );
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem('currentLanguage') &&
        localeOptions.filter(
          (x) => x.id === localStorage.getItem('currentLanguage')
        ).length > 0
        ? localStorage.getItem('currentLanguage')
        : defaultLocale;
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentLanguage -> error',
      error
    );
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentLanguage -> error',
      error
    );
  }
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem('gogo_current_user') != null
        ? JSON.parse(localStorage.getItem('gogo_current_user'))
        : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('gogo_current_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('gogo_current_user');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};

export const convertToFormData = (obj) => {
  const formData = new FormData();
  // eslint-disable-next-line
  for (const [key, value] of Object.entries(obj)) {
    formData.append(key, value);
  }
  return formData;
};


export const differenceDate = (end, current) => {
  const distance = end - current;
  return {
    distance,
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((distance % (1000 * 60)) / 1000),
  };
};

export const getAgeFromDOB = (dateOfBirth) => {

  try {
    const dob = new Date(dateOfBirth);
    const now = new Date();
    const diff = now - dob;
    const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));

    return age;

  } catch (error) {
    return -1;
  }

};

export const prependZero = (n) => {
  return Number(n) <= 9 ? `0${n}` : n;
};

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeFirstLetterWithSpace = (str) => {
  const val = str.charAt(0).toUpperCase() + str.slice(1);
  return val.replace(/([A-Z])/g, ' $1').trim()
};

export const convertToURLAndDownload = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const formatTokens = (tokens) => {
  return tokens?.toLocaleString('en-GB', {
    maximumFractionDigits: 0, // Ensures no decimal places
  });
};

export const formatNumber2DP = (number) => {
  return number?.toLocaleString('en-GB', {
    maximumFractionDigits: 2,
  });
};

export const formatCurrency = (amount) => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount || 0);
};

export const pluralise = (str, num) => {
  return num > 1 || num === 0 ? str.concat('s') : str;
};

export const getAuctionStyle = (auction, style) => {
  let displayStyle = 'secondary';
  if (auction.status === 'inProgress') {
    if (auction.totalBids > 0) {
      displayStyle = 'success';
    } else {
      displayStyle = 'info'
    }
    if (auction.broker_selection_notified) {
      displayStyle = 'danger';
    }
  } else if (auction.status === 'completed' || auction.status === 'cancelled') {
    displayStyle = 'primary';
  } else if (auction.status === 'draft' && auction.leadStatus === 'Sold') {
    displayStyle = 'success';
  }
  return style.replace('$$', displayStyle);
};

export const timeAgo = (timestamp) => {
  const seconds = Math.floor((Date.now() - timestamp) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) {
    return `${seconds} seconds ago`;
  } else if (minutes === 1) {
    return '1 minute ago';
  } else if (minutes < 60) {
    return `${minutes} minutes ago`;
  } else if (hours === 1) {
    return '1 hour ago';
  } else if (hours < 24) {
    return `${hours} hours ago`;
  } else if (days === 1) {
    return 'yesterday';
  } else if (days < 30) {
    return `${days} days ago`;
  } else if (months === 1) {
    return '1 month ago';
  } else if (months < 12) {
    return `${months} months ago`;
  } else if (years === 1) {
    return '1 year ago';
  } else {
    return `${years} years ago`;
  }
};

export const calculateAPR = (loanAmount, numInstallments, installmentAmount) => {

  const p = loanAmount;
  const a = installmentAmount;
  const n = numInstallments;
  const m = 12;
  const i = 0;
  const f = 0;

  let iterationCount = 0;
  const maxIterations = 1000;

  let x = 1.0001; let fx = 0; let dx = 0; let z = 0;
  do {
    fx = i + a * (Math.pow(x, n + 1) - x) / (x - 1) + f * Math.pow(x, n) - p;
    dx = a * (n * Math.pow(x, n + 1) - (n + 1) * Math.pow(x, n) + 1) / Math.pow(x - 1, 2) + n * f * Math.pow(x, n - 1);
    z = fx / dx; x = x - z;

    iterationCount++;
    if (iterationCount > maxIterations) {
      //console.error('APR calculation did not converge');
      return 0; // Return 0 or handle error as needed 
    }
  }
  while (Math.abs(z) > 1e-9);

  return 100 * (Math.pow(1 / x, m) - 1);
};

export const setDuration = (value, setFieldValue) => {
  if (!value) return null;

  const endDate = moment(value, 'DD/MM/YYYY');
  const dur = endDate.diff(moment().startOf('day'), 'days');
  setFieldValue("duration", dur.toString());

  return dur;
};

export const validateCoverDate = (value, fieldValues, momentInstance = moment) => {

  if (!value) return 'Cover date is required';


  const formattedDate = momentInstance(value, 'DD/MM/YYYY');
  if (!formattedDate.isValid()) {
    return 'Invalid date format';
  }
  const today = momentInstance().startOf('day');
  const maxFutureDate = momentInstance().add(60, 'days').startOf('day');
  if (formattedDate.isBefore(today)) {
    return 'The cover date cannot be in the past';
  } else if (formattedDate.isAfter(maxFutureDate)) {
    return 'The cover date must be up to 60 days in the future';
  }
  // can't be before auction end date           
  const auctionEndDate = momentInstance(fieldValues.auctionEndDate, 'DD/MM/YYYY');
  if (formattedDate.isBefore(auctionEndDate)) {
    return 'The cover date cannot be before the auction end date';
  }
  fieldValues.daysUntilCoverDate = momentInstance(value, 'DD/MM/YYYY').diff(moment().startOf('day'), 'days') - 1;


  return '';
};